import React from "react";

export interface BackNavigation {
    deeplink: string | null;
    screenName: string | null;
}

export interface BackNavigationContextValue {
    backAction: BackNavigation;
    setBackAction: (backAction: BackNavigation) => void;
}

export const BackNavigationContext = React.createContext<BackNavigationContextValue>({
    backAction: { deeplink: null, screenName: null },
    setBackAction: () => void 0,
});
